"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
var _default = {
  mixins: [],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100px'
    },
    value: {
      type: Number
    }
  },
  data: function data() {
    return {};
  },
  watch: {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},
  methods: {}
};
exports.default = _default;